import { t } from '@lingui/macro';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { isFinite } from 'lodash';

import Panel from '../../page-framework/panel/PanelDecorator';
import { panelPropTypes, panelPropDefaults } from '../../page-framework/panel/PanelPropTypes';
import usePanelDataService from '../../../services/PanelDataService';
import PerformanceChart from '../../charts/performance-chart/PerformanceChart';
import { BuiltInTooltip } from '../../charts/tooltip/types';
import { FORMATTER_TYPES } from '../../../utilities/FormattingUtilities';
import { timeRangeFilterId } from '../../filters';

const title = t`Test Result Processing Time per 5 Minutes`;
const PROCESSING_TIME_METRIC = 'ngpTRProcessingTime';

export const useStyles = makeStyles({
    chartContainer: {
        marginBottom: '2em',
    },
});

const dataSource = {
    url: '/query/chart',
    params: {
        type: 'ngphealth',
        metrics: [PROCESSING_TIME_METRIC],
    },
};

const chartConfig = {
    yAxis: [
        {
            title: {
                text: t`Processing time (s)`,
            },
            min: 0,
        },
    ],
    tooltip: BuiltInTooltip,
    showGranularity: true,
    metricMapping: (value) => {
        if (value === null) return null;
        if (!isFinite(value)) return undefined;

        return value / 1000;
    },
    chartTrends: [
        {
            formatter: FORMATTER_TYPES.DECIMAL,
            units: 's',
            chartType: 'spline',
            label: 'Processing time',
            key: PROCESSING_TIME_METRIC,
            color: '#5DA5DA',
            multiplier: 3,
            forceDecimals: true,
        },
    ],
};
function ProcessingTimePanel() {
    const classes = useStyles();
    const data = usePanelDataService(dataSource);
    const chartData = data?.data?.[0];

    if (!data) return null;

    return (
        <div className={clsx('flex-container', classes.chartContainer)}>
            <PerformanceChart
                chartDef={chartConfig}
                data={chartData}
                disableLegend
                xAxis={{ minTickInterval: 5 * 60 * 1000 }}
            />
        </div>
    );
}

ProcessingTimePanel.propTypes = panelPropTypes;

ProcessingTimePanel.defaultProps = {
    ...panelPropDefaults,
    title,
    contentHeight: 175,
    minContentHeight: 175,
};

export default Panel({
    typeAlias: 'nGPProcessingTimeTrend',
    filters: {
        required: [timeRangeFilterId],
        optional: [],
    },
})(ProcessingTimePanel);
